var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404PageNotFoundFlatline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 319 146",
    style: {
      enableBackground: "new 0 0 319 146"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EBCA94;}\r\n\t.st1{fill:#FFFFFF;stroke:#231F20;stroke-width:1.0454;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.06;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#D1D3D4;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_146_404_page_not_found_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,114.3H7.1V94.5l47.2-73.8h22.6v75.6H94v17.9H76.9v23.9H57V114.3z M57,48.9h-0.3L27.3,96.4H57V48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.9,114.3H226V94.5l47.2-73.8h22.6v75.6h17.1v17.9h-17.1v23.9h-19.9V114.3z M279.4,48.9h-0.3l-29.3,47.4 h29.7V48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.4,26.6c-29.1,0-52.7,23.6-52.7,52.7c0,29.1,23.6,52.7,52.7,52.7c29.1,0,52.7-23.6,52.7-52.7 C209.2,50.3,185.6,26.6,156.4,26.6C156.5,26.6,156.4,26.6,156.4,26.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 184.1,
    cy: 62.2,
    rx: 2.4,
    ry: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.5,63.7l123.8-27.4L194,29.2c0,0-13.2-21.9-16.7-22.3c-3.5-0.5-67.5,13.2-67.5,13.2l-4.1,30.8L94.5,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M135.9,90.3c0,0,31.5-12.6,45.2,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M181.1,101.7c-0.2,0-0.4-0.1-0.4-0.3c-13.4-22.8-44.3-10.7-44.6-10.6c-0.3,0.1-0.6,0-0.7-0.3 c-0.1-0.3,0-0.6,0.3-0.7l0,0c0.3-0.1,32-12.5,45.9,11.1c0.1,0.3,0.1,0.6-0.2,0.7C181.3,101.7,181.2,101.7,181.1,101.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "120.3,137.9 106.3,115.8 167.5,105.3 171.7,126.5 177.9,107 209.2,113.2 202.8,137.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.7,89.9l5.6-0.8l0,0l2.9,21.1c0.2,1.5-0.8,2.8-2.3,3l-0.3,0c-1.5,0.2-2.8-0.8-3-2.3L198.7,89.9L198.7,89.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.2,113.8c-1.6,0-2.9-1.2-3.2-2.8L198.2,90c0-0.3,0.2-0.5,0.4-0.6l5.6-0.8c0.1,0,0.3,0,0.4,0.1 c0.1,0.1,0.2,0.2,0.2,0.3l2.9,21.1c0.3,1.7-0.9,3.3-2.7,3.6c0,0,0,0,0,0l-0.3,0.1C204.5,113.8,204.4,113.8,204.2,113.8z  M199.3,90.4l2.8,20.6c0.2,1.2,1.3,2,2.4,1.9h0.3l0,0c1.2-0.2,2-1.3,1.8-2.4l-2.8-20.6L199.3,90.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.7,
    y: 70.6,
    transform: "matrix(0.9906 -0.1371 0.1371 0.9906 -9.2165 28.2282)",
    className: "st3",
    width: 9.2,
    height: 20.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.2,92.5c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3l-2.9-20.6c0-0.1,0-0.3,0.1-0.4 c0.1-0.1,0.2-0.2,0.3-0.2l9.1-1.3c0.3,0,0.5,0.1,0.6,0.4c0,0,0,0,0,0l2.9,20.6c0,0.3-0.2,0.5-0.4,0.6L197.2,92.5L197.2,92.5z  M194.9,71.8l2.7,19.6l8.1-1.1L203,70.7L194.9,71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M202.4,105.8l2.7-0.4c1.8-0.2,3.4,1,3.7,2.8l4.1,29.4c0.2,1.8-1,3.4-2.8,3.7l-2.7,0.4c-1.8,0.2-3.4-1-3.7-2.8 l-4.1-29.4C199.4,107.7,200.6,106,202.4,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.9,142.1c-1.9,0-3.5-1.4-3.7-3.2l-4.1-29.4c-0.1-1,0.1-2,0.7-2.8c0.6-0.8,1.5-1.3,2.5-1.5l2.7-0.4 c2-0.3,3.9,1.1,4.2,3.2l4.1,29.4c0.3,2-1.2,3.9-3.2,4.2l0,0l-2.7,0.4L206.9,142.1z M210,141.2L210,141.2z M205.5,105.9 c-0.1,0-0.3,0-0.4,0l-2.7,0.4c-0.7,0.1-1.4,0.5-1.8,1.1c-0.4,0.6-0.6,1.3-0.5,2l4.1,29.4c0.2,1.5,1.6,2.5,3,2.3l2.7-0.4 c1.5-0.2,2.5-1.6,2.3-3l-4.1-29.4C208,106.9,206.8,105.9,205.5,105.9L205.5,105.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 198.2,
    cy: 65.5,
    r: 24.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.1,90.4c-13.8,0-24.9-11.2-24.9-24.9s11.2-24.9,24.9-24.9c12.4,0,23,9.2,24.7,21.5l0,0 c1.9,13.6-7.6,26.2-21.2,28.1C200.5,90.3,199.3,90.4,198.1,90.4z M198.1,41.6c-1.1,0-2.2,0.1-3.3,0.2 c-13.1,1.8-22.2,13.9-20.4,26.9c1.8,13.1,13.9,22.2,26.9,20.4c13.1-1.8,22.2-13.9,20.4-26.9c0,0,0,0,0,0l0,0 C220.1,50.4,210.1,41.6,198.1,41.6L198.1,41.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 101.7878 250.5959)",
    className: "st3",
    cx: 198.2,
    cy: 65.5,
    rx: 19.8,
    ry: 19.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M198.2,85.8c-11.2,0-20.3-9.1-20.3-20.3s9.1-20.3,20.3-20.3c11.2,0,20.3,9.1,20.3,20.3 c0,10.1-7.5,18.7-17.5,20.1C200,85.7,199.1,85.8,198.2,85.8z M198.2,46.2c-0.9,0-1.8,0.1-2.7,0.2c-10.5,1.5-17.9,11.2-16.5,21.8 c1.5,10.5,11.2,17.9,21.8,16.5c10.5-1.5,17.9-11.2,16.5-21.8C215.9,53.3,207.8,46.2,198.2,46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.5,120.5c-1.3-1.7-3-3.1-5-4.1c-5.8-3-12.5-2.9-18.6-1c-2.2,0.7-6.4,1.7-6.6,4.6c0,1.2,0.8,2.2,1.9,2.5 c1.1,0.3,2.3,0.3,3.4,0.1c-1.6,0-3.2,0.4-4.6,1.2c-1.3,0.9-2,2.9-1,4.2c0.5,0.5,1.1,0.9,1.8,1c1.5,0.4,3,0.4,4.5-0.1 c-1.6,0.3-3.1,0.8-4.6,1.5c-0.9,0.4-1.9,1.1-1.8,2c0.1,0.9,1,1.4,1.8,1.6c1.8,0.6,3.6,0.9,5.4,1c-1.6,0.3-3.1,0.9-4.4,1.9 c-2,1.7-2,4.9,0.7,5.9c0.9,0.3,1.8,0.4,2.7,0.3c8.1,0,17.8-1,23.3-7.8c2.7-3.2,3.7-7.5,2.6-11.5 C222.8,122.6,222.2,121.5,221.5,120.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.2,143.6c-1,0-1.9-0.1-2.8-0.3c-1.2-0.4-2.2-1.4-2.4-2.7c-0.2-1.5,0.3-3.1,1.5-4.1c0.7-0.5,1.4-1,2.2-1.3 c-1-0.2-2.1-0.4-3-0.8c-1.3-0.5-2-1.2-2.2-2c-0.2-0.9,0.6-1.9,2-2.6l0.7-0.3c-0.2,0-0.4-0.1-0.5-0.1c-0.8-0.2-1.5-0.6-2-1.2 c-0.5-0.6-0.7-1.4-0.6-2.2c0.2-1.1,0.8-2.1,1.6-2.7c0.3-0.2,0.7-0.4,1-0.5c-1.2-0.5-2-1.6-1.9-2.9c0.2-3,3.9-4.1,6.3-4.8l0.6-0.2 c6.8-2.1,13.5-1.8,19,1c2,1,3.8,2.5,5.1,4.2c0.8,1.1,1.4,2.3,1.8,3.5c1.1,4.2,0.1,8.7-2.7,12C215.2,142.7,205.3,143.6,197.2,143.6 L197.2,143.6z M196.2,129.6c-1.1,0.3-2.2,0.7-3.3,1.1c-0.5,0.2-1.6,0.8-1.5,1.5c0.1,0.8,0.9,1,1.5,1.2c1.7,0.6,3.5,0.9,5.3,1 c0.3,0,0.5,0.2,0.5,0.4c0,0.3-0.1,0.5-0.4,0.5c-1.5,0.3-3,0.9-4.2,1.8c-0.9,0.8-1.4,1.9-1.2,3.1c0.2,0.9,0.9,1.6,1.7,1.9 c0.8,0.2,1.7,0.3,2.5,0.3c7.8,0,17.5-0.9,23-7.6c2.6-3,3.6-7.2,2.5-11c-0.4-1.2-0.9-2.2-1.7-3.2l0,0c-1.3-1.7-2.9-3-4.8-4 c-5.2-2.7-11.7-3-18.2-1l-0.7,0.2c-2.2,0.6-5.4,1.6-5.6,3.9c0,1,0.7,1.8,1.6,2c0.6,0.2,1.2,0.3,1.8,0.2c0.5-0.1,0.9-0.1,1.4-0.1 c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5c-0.5,0-0.9,0.1-1.4,0.1c-1,0.1-2.1,0.4-2.9,1c-0.7,0.5-1.1,1.2-1.2,2 c-0.1,0.5,0.1,1,0.4,1.4c0.4,0.4,0.9,0.7,1.5,0.8c1,0.3,2,0.3,3,0.2c0.4-0.1,0.8-0.2,1.2-0.3c0.3-0.1,0.5,0.1,0.6,0.4 c0.1,0.3-0.1,0.5-0.3,0.6C197.1,129.5,196.7,129.5,196.2,129.6L196.2,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.9,65.9c0,0,12.4,18.6,4.9,18.8c-7.5,0.3-8.1-1.7-8.1-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.4,85.3c-6.3,0-7.2-1.7-7.3-2c-0.1-0.3,0.1-0.6,0.3-0.7c0.3-0.1,0.6,0.1,0.7,0.3l0,0c0,0,0.9,1.6,7.6,1.3 c0.7,0.1,1.3-0.3,1.6-0.9c1.6-3.1-4.5-13.4-6.9-17.2c-0.1-0.3-0.1-0.6,0.2-0.7c0.2-0.1,0.5-0.1,0.7,0.1c0.9,1.4,9.1,14,7,18.3 c-0.5,0.9-1.5,1.5-2.5,1.4L168.4,85.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 199.3,
    cy: 64.9,
    rx: 4.5,
    ry: 7.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 144.4,
    cy: 64.9,
    rx: 3.4,
    ry: 6.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404PageNotFoundFlatline);
export default __webpack_public_path__ + "static/media/404 Page Not Found _Flatline.23805893cd7ab62be04fad3543b66af3.svg";
export { ForwardRef as ReactComponent };